import { motion, AnimatePresence } from 'framer-motion';
import { Check } from 'lucide-react';

const ConfirmationModal = ({ open, onClose, headline, subtext }) => {
  if (!open) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[200] flex items-center justify-center" data-testid="confirmation-modal">
        {/* Overlay — 80% dark, no close on click */}
        <div className="absolute inset-0 bg-black/80" />

        {/* Modal card */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="relative z-10 w-full max-w-md mx-4 rounded-xl overflow-hidden"
          style={{
            backgroundColor: '#080010',
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.015) 10px, rgba(255,255,255,0.015) 11px)',
          }}
        >
          {/* Lime top border */}
          <div style={{ height: '5px', backgroundColor: '#B8FF2E' }} />

          <div className="p-10 text-center">
            {/* Decorative check icon */}
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255,45,120,0.15)' }}>
                <Check size={32} style={{ color: '#FF2D78' }} strokeWidth={3} />
              </div>
            </div>

            {/* Headline */}
            <h2 className="font-display text-[40px] md:text-[48px] uppercase leading-none text-white">
              {headline}
            </h2>

            {/* Subtext */}
            <p className="font-body text-sm mt-4 leading-relaxed" style={{ color: '#F5F0EE' }}>
              {subtext}
            </p>

            {/* GOT IT button */}
            <button
              onClick={onClose}
              data-testid="confirmation-close-btn"
              className="w-full mt-8 py-4 font-display text-[18px] tracking-[1px] uppercase text-white rounded-lg transition-all duration-150 hover:scale-[1.02]"
              style={{ backgroundColor: '#FF2D78' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#E0005A'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#FF2D78'}
            >
              Got It
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default ConfirmationModal;
